import SimpleContentLayout from '@reader/SimpleContentLayout';
import { content } from 'content/algemeen';

export default function TermOfServicePage() {
  return <SimpleContentLayout content={content} />;
}
